import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import EditFormHtmlField from 'modules/ui/editform/fields/EditFormHtmlField';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EgyszeruKerdesEditService from 'app/admin/egyszerukerdes/service/EgyszeruKerdesEditService';
import FmStorageTableService from 'app/admin/fileManager/service/FmStorageTableService';
import FmBrowserTableService from 'app/admin/fileManager/service/FmBrowserTableService';
import nBossConnection from 'modules/base/service/nBossConnection';
import FejezetEditService from 'app/admin/fejezet/service/FejezetEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';

const config = {
	key: 'egyszeruKerdesEditForm',
	text: 'Egyszerű Kérdések',
	textKey: 'egyszeruKerdes',
	service: EgyszeruKerdesEditService,
	icon: 'person',
	tabList: [
		{
			key: 'basic',
			text: 'Alapadatok',
			textKey: 'basic'
		},
		{
			key: 'valasz',
			text: 'Válaszok',
			textKey: 'valasz'
		}
	],
	fields: [
		{
			key: 'sorszam',
			text: 'Sorszám',
			textKey: 'sorszam',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'alSorszam',
			text: 'Alsorszám',
			textKey: 'alSorszam',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'subSorszam',
			text: 'Sub sorszám',
			textKey: 'subSorszam',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		/*{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			component: EditFormTextField,
			required: true
		},*/
        {
			key: 'leiras',
			text: 'Leírás',
			textKey: 'leiras',
			component: EditFormHtmlField,
			storageService: FmStorageTableService,
			browserService: FmBrowserTableService,
			getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
			required: true
		},
        {
			key: 'magyarazat',
			text: 'Magyarázat',
			textKey: 'magyarazat',
			component: EditFormHtmlField,
			storageService: FmStorageTableService,
			browserService: FmBrowserTableService,
			getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
			required: true
		},
		{
			key: 'nemperm',
			text: 'Nem permutálható',
			textKey: 'nemperm',
			component: EditFormCheckboxField,
			required: true
		},
		{
			key: 'statuszId',
			text: 'Módosítva',
			textKey: 'statuszId',
			component: EditFormCheckboxField,
			required: true
		},
		{
			key: 'feladatCsoport',
			text: 'Feladatcsoport',
			textKey: 'feladatCsoport',
			component: EditFormSelectField,
			required: true,
			items: () => FejezetEditService.getFeladatCsoportSelection()
		},
		{
			key: 'fejezet',
			text: 'Fejezet',
			textKey: 'fejezet',
			component: EditFormSelectField,
			required: true,
			items: () => FejezetEditService.getFejezetSelection()
		},
		{
			key: 'valasz',
			text: 'Válasz',
			textKey: 'valasz',
			tab: 1,
			component: EditFormSubComponent,
			watchTitleKey: 'betujel',
			defaultValue: {
				id: null,
				betujel: null,
				helyes: false,
				szoveg: null,
				magyarazat: null
			},
			fields: [
				{
					key: 'betujel',
					text: 'Betűjel',
					textKey: 'betujel',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'helyes',
					text: 'Helyes',
					textKey: 'helyes',
					component: EditFormCheckboxField,
					required: true
				},
				{
					key: 'szoveg',
					text: 'Szöveg',
					textKey: 'szoveg',
					component: EditFormHtmlField,
					storageService: FmStorageTableService,
					browserService: FmBrowserTableService,
					getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
					required: true
				},
				{
					key: 'magyarazat',
					text: 'Magyarázat',
					textKey: 'magyarazat',
					component: EditFormHtmlField,
					storageService: FmStorageTableService,
					browserService: FmBrowserTableService,
					getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
					required: true
				}
			]
		}
	]
};

function EgyszeruKerdesEditForm() {
	return <EditFormPage config={config} />;
}

export default EgyszeruKerdesEditForm;
